<template>
    <div class="main-div">
        <HeaderRemoveBlock @closeDialog="closeDialog" />
        <MainBlock />
        <FooterBlock @closeDialog="closeDialog" />
    </div>
</template>
<script setup lang="ts"> 
import { ModalNames } from '~/types/modals';
import FooterBlock from './FooterBlock.vue';
import HeaderRemoveBlock from './HeaderBlock.vue';
import MainBlock from './MainBlock.vue';

const dialogRef = getDialogRef(ModalNames.BLOCK_CONTACT);
const closeDialog = () => {
    dialogRef.value.close();
};
</script>
<style lang="scss" scoped>
.main-div {
    @apply sm:max-w-xl w-11/12 rounded-lg bg-white mx-auto flex flex-col items-center self-stretch shadow-cardshadow ;
}
</style>